import type { Profile } from '@nutians/shared/schemas';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api.js';

export const PROFILE_KEY = ['profile'] as const;

export function useProfile(enabled = true) {
  return useQuery<Profile>({
    queryKey: PROFILE_KEY,
    queryFn: async (): Promise<Profile> => {
      const { data, error } = await api.GET('/me/profile');
      if (error || !data) throw new Error('GET /me/profile failed');
      return data as Profile;
    },
    enabled,
    staleTime: 30_000,
    retry: false,
  });
}
